<div class="background-style">
  <mat-toolbar class="top_toolbar" style="background-color: #336989; color: white; position: relative;">
    <mat-toolbar-row>
      <div class="logowrapper">
        @if (!menuButtonDisabled || goBackButtonUrl !== undefined) {
          <div class="left">
            @if (!isDesktop && !menuButtonDisabled) {
              <button
                id="tour-menu-btn"
                (click)="menuButtonClicked()"
                class="menu"
                mat-icon-button
                color="basic"
                aria-label="Open Menu"
                i18n-aria-label="@@HeaderToolbar_OpenMenu"
                matTooltip="Menu"
                i18n-matTooltip="@@HeaderToolbar_Menu"
              >
                <mat-icon>menu</mat-icon>
              </button>
            }
            @if (goBackButtonUrl !== undefined) {
              <button (click)="goBackButtonClicked()" class="menu" mat-icon-button color="basic">
                <mat-icon>arrow_back</mat-icon>
              </button>
            }
          </div>
        }
      </div>
      <div class="center-container">
        <mat-label class="title" [matTooltip]="title || ''">{{ title ? title : 'Lars' }}</mat-label>
        <!-- if needed to center title (odd number of mat-tool-bar-row children) -->
      </div>
      @if (backButtonEnabled && userMenuDisabled && goBackButtonUrl !== undefined) {
        <div class="right"></div>
      }
      <div class="right-aligned-container">
        @if (showUserProfileButton) {
          <app-user-notification></app-user-notification>
        }
        <button mat-icon-button aria-label="Report a Bug" i18n-aria-label="@@HeaderToolbar_sentryFormTitle" id="reportBug" matTooltip="Report a Bug" i18n-matTooltip="@@HeaderToolbar_sentryFormTitle">
          <img src="assets/feedbackIcon.svg" class="feedback-icon" alt="feedback" i18n-alt="@@HeaderToolbar_Feedback"/>
        </button>
        <button mat-fab
                title="User Icon Button"
                i18n-title="@@HeaderToolbar_UserIconButton"
                #userMenuTrigger="matMenuTrigger"
                matTooltip="User Profile"
                i18n-matTooltip="@@HeaderToolbar_UserProfileTooltip"
                [matMenuTriggerFor]="isUserProfilePage ? null : userMenu"
                class="user-icon-btn"
                color="basic"
                [disabled]="!showUserProfileButton"
                [style.visibility]="showUserProfileButton ? 'visible' : 'hidden'"
                [style.backgroundImage]="userIconCssProperty"
                (click)="handleUserIconClick(userMenuTrigger)">
        </button>
      </div>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span i18n="@@HeaderToolbar_Logout">Logout</span>
        </button>
        <button mat-menu-item (click)="navigateToUserProfile()">
          <mat-icon>account_circle</mat-icon>
          <span  i18n="@@HeaderToolbar_UserProfile">User Profile</span>
        </button>
      </mat-menu>

    </mat-toolbar-row>

    @if (subtitle !== undefined) {
      <mat-toolbar-row>
        <mat-label>{{ subtitle }}</mat-label>
      </mat-toolbar-row>
    }
  </mat-toolbar>
</div>
